import { Button } from "@hulahoop/ui";
import { useTranslation } from "react-i18next";
import { ROUTES } from "@/app/routes";
import { FullScreenCenter } from "@/components/shared/layout/FullScreenCenter";
import { forceNavigate, reloadPage } from "@/infrastructure/navigation";

/** Must also work outside RouterProvider and the application's providers. */
export function ErrorScreen() {
  const { t } = useTranslation(undefined, { useSuspense: false });
  return (
    <FullScreenCenter as="main" role="alert" className="flex-col gap-4 p-6">
      <h1 className="text-xl font-semibold">{t("foundation.error.title")}</h1>
      <p className="text-muted-foreground">{t("foundation.error.description")}</p>
      <div className="flex gap-3">
        <Button onClick={reloadPage}>{t("foundation.reload")}</Button>
        <Button variant="outline" onClick={() => forceNavigate(ROUTES.DASHBOARD)}>
          {t("foundation.home")}
        </Button>
      </div>
    </FullScreenCenter>
  );
}
